import React, { useState, useEffect } from 'react';

// Services
import { paymentMethods } from 'services/constants';

// Components
import SelectMultiple from 'components/select-multiple';

// ---------------------------------------------------------------------------------------------- \\
// ------------------------------------ SELECT REFUND METHODS ----------------------------------- \\
// ---------------------------------------------------------------------------------------------- \\

const SelectRefundMethods = ({ methods, setMethods }) => {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        setOptions(paymentMethods
            .filter(m => m.value !== 'ticket' && m.value !== 'cash')
            .map(s => ({ label: s.label, value: s.value }))
        );
    }, []);

    return (
        <SelectMultiple
            value={methods}
            onChange={value => setMethods(value)}
            options={options}
            placeholder="Mode de remboursement"
        />
    );
};

export default SelectRefundMethods;
